// Billing/PlanCard (Figma 23:123) for the three purchasable tiers on frame
// 19. Every price/domain/pageview figure comes from `pricing.ts`, which is
// checked line by line against docs/business/05 §2.2 — never hand-typed here.

import { Badge } from "../../ui/Badge";
import { Button } from "../../ui/Button";
import { PLAN_INFO, type PlanId } from "./pricing";
import "./commerce.css";

export type PlanCardProps = {
  tier: PlanId;
  isCurrent: boolean;
  supportHref: string;
  /** Fires the "honestly inert" message instead of starting any checkout —
   *  there is no payment-provider import and no redirect URL in this file. */
  onInert: (message: string) => void;
};

export function PlanCard({ tier, isCurrent, supportHref, onInert }: PlanCardProps) {
  const info = PLAN_INFO[tier];
  return (
    <div className="maisight-commerce-plan-card" data-current={isCurrent}>
      <div className="maisight-commerce-plan-card-head">
        <span
          className="type-label maisight-commerce-plan-card-name"
          data-current={isCurrent}
        >
          {info.label}
        </span>
        {isCurrent ? (
          <Badge tone="nominal" lamp>
            current
          </Badge>
        ) : null}
      </div>
      <div className="maisight-commerce-plan-card-price">
        <span className="maisight-commerce-plan-card-price-value">
          {info.price}
        </span>
      </div>
      {info.cadenceNote ? (
        <span className="type-bodyS maisight-commerce-plan-card-price-note">
          {info.cadenceNote}
        </span>
      ) : null}
      <p className="type-bodyS maisight-commerce-plan-card-detail">
        {info.domains} · {info.pageviewCeiling}
      </p>
      <div className="maisight-commerce-plan-card-spacer" />
      {isCurrent ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            onInert(
              "Annual billing isn't self-serve yet. Contact us and we'll switch your invoicing cadence by hand.",
            )
          }
        >
          Switch to annual
        </Button>
      ) : tier === "enterprise" ? (
        <Button to={supportHref} variant="secondary" size="sm">
          Talk to sales
        </Button>
      ) : (
        <Button
          variant={tier === "scale" ? "primary" : "secondary"}
          size="sm"
          onClick={() =>
            onInert(
              `Self-serve checkout for ${info.label} isn't live yet. Contact us and we'll switch your plan by hand.`,
            )
          }
        >
          Upgrade to {info.label}
        </Button>
      )}
    </div>
  );
}
